export type Maybe<T> = T | null | undefined

export const Maybe = {
  map: <T, U>(f: (t: T) => U) => (t: Maybe<T>): Maybe<U> => {
    if (t === null) return null
    if (t === undefined) return undefined
    return f(t)
  },
}
